// extracted by mini-css-extract-plugin
export var close = "SuccessPopup-module--close--DHI8n";
export var cta = "SuccessPopup-module--cta--MsC+T";
export var root = "SuccessPopup-module--root--9ngb1";
export var title = "SuccessPopup-module--title--3vlab";